import React from "react";
import { ArrowDownIcon, ArrowUpRightIcon } from "lucide-react";
const HERO_URL = "https://cdn.magicpatterns.com/uploads/sqNUmzAUg1DMR2RQ7AzH3N/haul-truck-sunset.webp";
const CAREERS_URL = "https://bigyellow.au/careers/";
const quickFacts = [{
  label: "The work",
  value: "FIFO & site-based roles"
}, {
  label: "The operations",
  value: "Open-cut gold & iron ore"
}, {
  label: "Head office",
  value: "Welshpool, WA"
}];
export function Hero() {
  return <section id="top" aria-labelledby="hero-heading" className="relative flex min-h-[760px] items-end overflow-hidden bg-black text-white md:min-h-screen" data-id="element-235" data-mp="ms7q5w8ng9wn">
      <img src={HERO_URL} alt="Big Yellow haul truck at an open-cut operation at sunset" width={1440} height={1080} fetchPriority="high" className="absolute inset-0 h-full w-full object-cover object-[64%_center] sm:object-center" data-id="element-236" data-mp="vnnfq12dg2wf" />
      <div className="absolute inset-0 bg-black/55 sm:bg-black/45" data-id="element-237" data-mp="1aitpmz4l8lv1" />

      <div className="relative z-10 mx-auto w-full max-w-[1600px] px-6 pb-10 pt-40 lg:px-12 lg:pt-56 xl:px-20" data-id="element-238" data-mp="9nswtp4hi3d5">
        <div className="max-w-5xl" data-id="element-239" data-mp="4o6nhqrs179m">
          <p className="mb-5 text-[0.8125rem] font-semibold uppercase tracking-[0.16em] text-[#FFCF53] sm:text-sm" data-id="element-240" data-mp="4n4yeidxek8w">Gold mining careers · Western Australia</p>
          <h1 id="hero-heading" className="max-w-5xl text-[clamp(3.2rem,7vw,7.6rem)] font-bold uppercase leading-[0.88] tracking-[-0.05em]" data-id="element-241" data-mp="3rtp9ue55baxa">
            Your next move.<br data-id="element-242" data-mp="sdir8b4c4n4j" />
            <span className="text-[#FFCF53]" data-id="element-243" data-mp="sg4z6bv514na">Make it big.</span>
          </h1>
          <p className="mt-7 max-w-2xl text-lg leading-8 text-white/90 md:text-xl" data-id="element-244" data-mp="nfze5ejdige6">
            Explore open-cut mining opportunities with Big Yellow. Experienced teams. Serious equipment. A commitment that reaches beyond the mine.
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-245" data-mp="1b5bnceepaogh">
            <a href={CAREERS_URL} className="btn btn-primary" data-id="element-246" data-mp="1b6wdzsxw9n92">
              View opportunities <ArrowUpRightIcon aria-hidden="true" size={20} className="btn-icon" data-id="element-247" data-mp="16cs87d0d7l9k" />
            </a>
            <button type="button" data-open-eoi className="btn btn-ghost-light" data-id="element-248" data-mp="30mpado4fweok">
              Register your interest <ArrowUpRightIcon aria-hidden="true" size={20} className="btn-icon" data-id="element-249" data-mp="35k8s4y0cj9l9" />
            </button>
          </div>
          <p className="mt-4 text-sm text-white/70" data-id="element-250" data-mp="2qu9q2k5o7e0i">Current vacancies open on Big Yellow&apos;s careers page. Registering interest takes a name, email and area of work.</p>
        </div>

        <dl className="mt-14 grid grid-cols-2 gap-5 border-t border-white/25 pt-6 lg:grid-cols-4 md:mt-20" data-id="element-251" data-mp="2hxippvk35d04">
          {quickFacts.map(fact => <div key={fact.label} data-id="element-252" data-mp="27y1n5n04rf8d">
              <dt className="text-xs font-semibold uppercase tracking-[0.14em] text-[#FFCF53]" data-id="element-253" data-mp="27z2x1o5etvoi">{fact.label}</dt>
              <dd className="mt-1.5 text-base font-medium text-white" data-id="element-254" data-mp="2cyfkob43v6s5">{fact.value}</dd>
            </div>)}
          <div data-id="element-255" data-mp="b4zq534wd7rw">
            <dt className="text-xs font-semibold uppercase tracking-[0.14em] text-[#FFCF53]" data-id="element-256" data-mp="b5hw4rhd30d0">Beyond the mine</dt>
            <dd className="mt-1.5" data-id="element-257" data-mp="1vm8zsvp0yjdz">
              <a href="#community" className="group inline-flex items-center gap-2 text-base font-medium text-white underline decoration-[#FFCF53] decoration-2 underline-offset-4 transition-colors duration-150 hover:text-[#FFCF53]" data-id="element-258" data-mp="1vnaav061j5vp">
                5% of profits to community
                <ArrowDownIcon aria-hidden="true" size={15} className="transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] group-hover:translate-y-0.5" data-id="element-259" data-mp="20lbrlefzut40" />
              </a>
            </dd>
          </div>
        </dl>
      </div>
    </section>;
}